import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { KnowledgeSuggestionDismissDialog } from "modules/knowledge/components/KnowledgeSuggestionDismissDialog"
import { Route as SuggestionsRoute } from "routes/_base/_auth/knowledge/suggestions"

export const Route = createFileRoute("/_base/_auth/knowledge/suggestions/$gapId/dismiss")({
  component: RouteComponent,
})

function RouteComponent() {
  const { gapId } = Route.useParams()
  const search = SuggestionsRoute.useSearch()
  const navigate = useNavigate()

  function onClose() {
    navigate({ to: "/knowledge/suggestions", search })
  }

  return <KnowledgeSuggestionDismissDialog gapId={gapId} onClose={onClose} />
}
